// Readable colours for content placed on a boutique colour (storefront header and footer).

const DARK_TEXT = '#1c1917';
const LIGHT_TEXT = '#ffffff';

// "#ff4d00" / "#f40" -> [255, 77, 0]; null when the value is not a hex colour.
const hexToRgb = (hex) => {
  const clean = String(hex || '').trim().replace('#', '');
  const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean;
  if (!/^[0-9a-f]{6}$/i.test(full)) return null;
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
};

// WCAG relative luminance (0 = black, 1 = white). Unknown colours count as white.
export const luminance = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return 1;
  const [r, g, b] = rgb.map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const contrastRatio = (a, b) => {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
};

/**
 * Text, muted text, border, hover and accent colours that stay readable on `background`.
 * The accent (usually the boutique's primary colour) is only kept when it stands out
 * on the background (contrast >= 3); otherwise the text colour is used instead.
 */
export const surfaceColors = (background, accent) => {
  const isLight = contrastRatio(background, DARK_TEXT) >= contrastRatio(background, LIGHT_TEXT);
  const text = isLight ? DARK_TEXT : LIGHT_TEXT;
  return {
    background,
    isLight,
    text,
    muted: isLight ? 'rgba(28, 25, 23, 0.65)' : 'rgba(255, 255, 255, 0.82)',
    border: isLight ? 'rgba(28, 25, 23, 0.08)' : 'rgba(255, 255, 255, 0.18)',
    hover: isLight ? 'rgba(28, 25, 23, 0.06)' : 'rgba(255, 255, 255, 0.14)',
    accent: accent && contrastRatio(background, accent) >= 3 ? accent : text,
  };
};
